import { ComponentStyleConfig } from "@chakra-ui/react";

const MenuTheme: ComponentStyleConfig = {
  baseStyle: {
    list: {
      zIndex: 1000,
      overflowY: "auto",
      color: "gray.900",
    },
    item: {
      fontSize: 14,
      _hover: {
        bg: "primary.50",
      },
      _active: {
        bg: "primary.100",
      },
      "&.destructive": {
        color: "error.500",
        _hover: {
          bg: "error.100",
        },
      },
    },
  },
  variants: {
    select: {
      list: {
        overflow: "hidden",
        py: 0,
        minWidth: "320px",
        border: "none",
        boxShadow:
          "0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
        borderRadius: "6px",
      },
      item: {
        minHeight: "40px",
      },
    },
  },
};

export default MenuTheme;
